class ReadMore extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.holder = this.querySelector('[data-holder]');
    this.content = this.querySelector('[data-content]');
    this.button = this.querySelector('[data-button]');
    // Add events
    this.button.addEventListener('click', () => {
      this.toggleReadMore();
    });
    // Define the media query
    this.mediaQuery = window.matchMedia('(min-width: 1024px)');

    // Initial check
    this.handleMediaQueryChange(this.mediaQuery);

    // Add an event listener to the media query
    this.mediaQuery.addEventListener('change', handleMediaQueryChange);
  }

  // Function to handle changes in media query
  handleMediaQueryChange(event) {
    this.classList.remove('open');
    this.classList.remove('no-button');

    // Check the breakpoint and the height of the content compared to holder height
    if (event.matches == false && this.content.offsetHeight > this.holder.offsetHeight) {
      this.classList.remove('no-button');
    } else {
      this.classList.add('no-button');
    }
  }

  toggleReadMore() {
    this.classList.toggle('open');
  }
}

customElements.define('read-more', ReadMore);
